module.exports = __webpack_public_path__ + "img/back.e5b5d9b2.png";